import AddableTagsAutoComplete from './AddableTagsAutoComplete'

export default AddableTagsAutoComplete
